import "../packs/core/services/analytics/cmp/bootstrap-cmp";
import { loadComponent } from "../packs/config/loader";
import { VouchersDistribution } from "../packs/core/modules/vouchers-distribution/pages";
import { OrderConfirmationPage } from "../packs/core/modules/vouchers-distribution/order-confirmation/pages";
import { AnalyticsHub } from "../packs/core/services/analytics/analytics-hub";

document.addEventListener("DOMContentLoaded", () => {
	loadComponent(VouchersDistribution, document.getElementById("vouchers-distribution-js"));
	loadComponent(OrderConfirmationPage, document.getElementById("vouchers-distribution-order-confirmation-js"));

	let node = document.getElementById("analytics-hub-js");
	if (!node) {
		node = document.createElement("div");
		node.id = "analytics-hub-js";
		document.body.appendChild(node);
	}
	loadComponent(AnalyticsHub, node);
});
